import { memo } from 'react'
import { EnvelopeIcon, PhoneIcon, CalendarIcon } from '@heroicons/react/24/outline'

/**
 * UserMetadataView - Displays user details in read-only mode
 * Shows contact info and account dates
 */
const UserMetadataView = memo(function UserMetadataView({
  user
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-center text-gray-600">
        <EnvelopeIcon className="h-5 w-5 mr-3 text-gray-400" />
        <span>{user?.email}</span>
      </div>
      {user?.phone && (
        <div className="flex items-center text-gray-600">
          <PhoneIcon className="h-5 w-5 mr-3 text-gray-400" />
          <span>{user.phone}</span>
        </div>
      )}
      <div className="flex items-center text-gray-600">
        <CalendarIcon className="h-5 w-5 mr-3 text-gray-400" />
        <span>Joined {new Date(user?.createdAt).toLocaleDateString()}</span>
      </div>
      {user?.lastLoginAt && (
        <div className="flex items-center text-gray-600">
          <CalendarIcon className="h-5 w-5 mr-3 text-gray-400" />
          <span>Last login {new Date(user.lastLoginAt).toLocaleDateString()}</span>
        </div>
      )}
    </div>
  )
})

export default UserMetadataView
